@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: min(560px, 100%);
  max-width: 720px;
}

.statusMessage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 120px;
  color: var(--text-soft);

  p {
    margin: 0;
    @include typography-v2-body-base;
  }
}

.clarificationTitle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.clarification {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.editInput {
  @include typography-v2-body-base;
  @include border-radius-r2;
  width: 100%;
  padding: 8px 12px;
  resize: none;
  background: var(--surface-default);
  border: 1px solid var(--border-soft);
  color: var(--text-default);

  &:focus,
  &:focus-visible {
    border-color: var(--border-primary);
    outline: none;
  }
}

.editActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
